import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import ListItem from '@zenbusiness/zui/ListItem';
import PageContainer from '@zenbusiness/zui/PageContainer';
import PageHeader from '@zenbusiness/zui/PageHeader';
import SkeletonGrid from '@zenbusiness/zui/SkeletonGrid';
import Text from '@zenbusiness/zui/Text';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';

import { useBusinessEntities } from '#client/hooks/useBusinessEntities';
import { BusinessEntityCard } from '#client/pages/BusinessOverview/BusinessEntityCard';

import * as Styled from './BusinessOverview.styles';

const BusinessOverview = () => {
  const { sizes } = useBreakpoints();

  const { loading, businessEntities } = useBusinessEntities();

  const renderContent = () => {
    if (loading) {
      let columns = sizes.isDesktop ? 3 : 2;
      columns = sizes.isMobile ? 1 : columns;

      return <SkeletonGrid columns={columns} count={6} />;
    }

    return (
      <Styled.ListCard>
        {businessEntities.map(({ uuid, name }) => (
          <ListItem key={uuid} sx={{ padding: 0 }}>
            <BusinessEntityCard uuid={uuid} name={name} />
          </ListItem>
        ))}
      </Styled.ListCard>
    );
  };

  return (
    <PageContainer
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        mt: 0,
      }}
    >
      <PageHeader
        title={
          <Text size="2xl">
            <FormattedMessage id="dashboard.businessOverview.title" />
          </Text>
        }
        sx={{ mb: 0 }}
      />
      {renderContent()}
    </PageContainer>
  );
};

export default BusinessOverview;
